import * as PropTypes from 'prop-types';
import * as React from 'react';
import UrlHelpers from '../../shared/url_helpers';
import * as ReactDOMServer from 'react-dom/server';
import PriceDisplay from '../../shared/price_display';
import ShippingPrice from '../../listings/shipping_price';
import * as classNames from 'classnames';
import TaxIncludedHint from '../../shared/tax_included_hint';

class ModalProductSummary extends React.Component {
  get itemsBundledCount() {
    if (this.cartItem.acceptsDirectCheckout) {
      return this.props.directCheckoutCartCount;
    }
    return 1;
  }

  get cartItem() {
    return this.props.cartItem;
  }

  get checkoutPath() {
    return this.cartItem.preferredCheckoutLink;
  }

  isOnSale() {
    return this.cartItem.eligibleSale;
  }

  renderProceedToCheckoutButton() {
    if (this.props.zeroPercentAffirmFinancing) { return null; }

    return (
      <a
        id="proceed-to-checkout"
        href={this.checkoutPath}
        className="button button--green size-90 ml-2 mobile-ml-0 mobile-width-100 mt-1"
      >
        {I18n.t('js.addToCart.successModal.proceedToCheckout', { count: this.itemsBundledCount })}
      </a>
    );
  }

  renderCartButton() {
    const classes = classNames(
      'button',
      { 'button--green': this.props.zeroPercentAffirmFinancing },
      'mobile-width-100',
      'size-90',
      'mt-1',
    );

    return (
      <a
        id="view-cart"
        href={UrlHelpers.cartPath}
        className={classes}
      >
        {I18n.t('js.addToCart.successModal.viewCart')}
      </a>
    );
  }

  renderShopLink() {
    const link = (
      <a
        href={this.cartItem._links.seller.web.href}
      >
        {this.cartItem.shopName}
      </a>
    );
    const translation = I18n.t('js.addToCart.successModal.soldBy', {
      shop_link: ReactDOMServer.renderToString(link),
    });

    return (
      <p
        className="size-80 mb-0 lh-120"
        dangerouslySetInnerHTML={{ __html: translation }}
      />
    );
  }

  renderPlaceholder() {
    return (
      <div className="loading-placeholder-content">
        <div className="g-container">
          <div className="g-col-2">
            <div className="placeholder-image fluid-square" />
          </div>
          <div className="g-col-4 g-col-mobile-6">
            <div className="placeholder-p mb-1" />
            <div className="placeholder-p quarter-width mtb-half" />
          </div>
          <div className="g-col-6 g-col-mobile-4">
            <div className="align-right">
              <div className="placeholder-p quarter-width inline-block" />
              <br />
              <div className="placeholder-p quarter-width inline-block mb-1" />
              <br />
              <div className="show-only-on-desktop">
                <div className="placeholder-btn size-large inline-block mr-half" />
                <div className="placeholder-btn size-large inline-block" />
              </div>
            </div>
          </div>
        </div>
        <div className="mt-1 show-only-on-mobile">
          <div className="placeholder-btn size-large wide mb-1" />
          <div className="placeholder-btn size-large wide" />
        </div>
      </div>
    );
  }

  renderSaleReminder() {
    if (this.isOnSale()) {
      return (
        <p className="cart-sale-reminder">
          {this.cartItem.saleReminderText}
        </p>
      );
    }
    return null;
  }

  renderOriginalPrice() {
    if (!this.cartItem.originalItemPrice) { return null; }

    return (
      <p className="opacity-70 mb-0">
        <strike>
          <PriceDisplay
            price={this.cartItem.originalItemPrice}
            showCurrency={false}
          />
        </strike>
      </p>
    );
  }

  renderPrice() {
    const classes = classNames(
      'mb-0',
      { 'color-red': this.isOnSale() },
    );

    return (
      <p className={classes}>
        <PriceDisplay price={this.cartItem.itemPrice} />
      </p>
    );
  }

  render() {
    if (!this.cartItem) { return this.renderPlaceholder(); }

    return (
      <div>
        <div className="d-flex fx-align-center fx-justify-between">
          <div className="fx-width-20">
            <div className="image-box bd-1 bd--offwhite">
              <img
                src={this.cartItem.thumbnail}
                alt={this.cartItem.title}
              />
            </div>
          </div>
          <div className="scaling-mlr-2 fx-grow">
            {this.renderSaleReminder()}
            <p className="lh-120 mobile-size-90 scaling-mb-half">{this.cartItem.title}</p>
            {this.renderShopLink()}
          </div>
          <div className="align-right">
            {this.renderOriginalPrice()}
            {this.renderPrice()}
            <div className="size-80 opacity-70">
              <ShippingPrice shippingRate={this.cartItem.shippingPrice} />
            </div>
            <div className="size-80 opacity-70">
              <TaxIncludedHint hint={this.cartItem.taxIncludedHint} />
            </div>
          </div>
        </div>
        {this.props.showActions &&
          <div className="align-center bdt-1 bd--offwhite pt-1 scaling-mt-2">
            {this.renderCartButton()}
            {this.renderProceedToCheckoutButton()}
          </div>
        }
      </div>
    );
  }
}

ModalProductSummary.propTypes = {
  cartItem: PropTypes.object,
  zeroPercentAffirmFinancing: PropTypes.bool,
  directCheckoutCartCount: PropTypes.number,
  showActions: PropTypes.bool,
};

ModalProductSummary.defaultProps = {
  zeroPercentAffirmFinancing: false,
  showActions: true,
};

export default ModalProductSummary;



// WEBPACK FOOTER //
// ./javascripts/components/listings/cart/modal_product_summary.jsx